<div class="custom-checkbox-element" (click)="handleClick()" [class.disabled]="disabled()">
  <div class="custom-checkbox-icon" [class.checked]="checked()">
    @if (checked()) {
      <svg class="check-icon" width="12" height="10" viewBox="0 0 12 10" fill="none">
        <path
          d="M1 5L4.5 8.5L11 1"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </div>
  <div class="custom-checkbox-label" [class.checked]="checked()">
    <ng-content></ng-content>
  </div>
</div>
